import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal } from "@mantine/core";
import { Button, Container, CssBaseline } from "@mui/material";
import AgreementContent from "./AgreementContent"; // Import AgreementContent

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const AgreementModal = ({
  isOpen,
  onRequestClose,
  onSignatureAdded,
  onPdfGenerated,
  setEnvelopeId,
  setAgreementUrl,
  envolpeId,
  signUrl,
  setSignUrl,
  setIsDocusignModalOpen,
  setIsFetching,
  setDocumentFetched,
  agreementDetails,
  activeTab,
}) => {
  const componentRef = useRef();

  const [backdropopen, setbackdropopen] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const isMobile = window.innerWidth < 768


  return (
    <>
      {" "}
      <Backdrop sx={{ color: "#fff", zIndex: "3000" }} open={backdropopen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        opened={isOpen}
        onClose={onRequestClose}
        contentLabel="Agreement Modal"
        ariaHideApp={false}
        size={'800px'}

        padding={"md"}
        fullScreen={isMobile}


      >

        <AgreementContent
          ref={componentRef}
          onSignatureAdded={onSignatureAdded}
          onPdfGenerated={onPdfGenerated}
          setEnvelopeId={setEnvelopeId}
          setAgreementUrl={setAgreementUrl}
          envolpeId={envolpeId}
          setbackdropopen={setbackdropopen}
          onRequestClose={onRequestClose}
          setSignUrl={setSignUrl}
          signUrl={signUrl}
          setIsDocusignModalOpen={setIsDocusignModalOpen}
          setIsFetching={setIsFetching}
          setDocumentFetched={setDocumentFetched}
          agreementDetails={agreementDetails}
          activeTab={activeTab}
        />
      </Modal>
    </>
  );
};

export default AgreementModal;
